import { LanguageService } from '../services';

export default function getFlagIconClassname(locale?: string): string {
    if (!locale) {
        return '';
    }

    const flagName = LanguageService.getCountryCode(locale).toLowerCase();
    return `fi fi-${flagName}`;
}
